import { Typography } from "@circle-react-shared/uikit/Typography";

import { t } from "@/i18n-js/instance";

import { CONFIRMATION_PAGE_LOCALE_ROOT } from "../constants";

interface TitleProps {
  memberName?: string;
}

export const Title = ({ memberName }: TitleProps) => {
  const [locale, localeOptions] = memberName
    ? [
        `${CONFIRMATION_PAGE_LOCALE_ROOT}.title`,
        { community_member_name: memberName },
      ]
    : ["thanks", {}];

  return (
    <div className="flex flex-col gap-y-1">
      <Typography.LabelLg
        weight="semibold"
        color="text-primary"
        data-testid="checkout-confirmation-title"
      >
        {t(locale, localeOptions)}
      </Typography.LabelLg>
      <Typography.BodySm color="text-secondary">
        {t([CONFIRMATION_PAGE_LOCALE_ROOT, "subtitle"])}
      </Typography.BodySm>
    </div>
  );
};
